import { createSelector } from 'redux-starter-kit'

const getLayerTimestamps = (state, id) => {
  return state.iceDrift
}
    
const getId = (state, id) => {
  return id
}

export const makeGetTimestamps = () => {
  return createSelector(
    [getLayerTimestamps, getId],
    (timestamps, id) => {
      return timestamps[id]
    },
    { deepEqual: true }
  )
}



// WEBPACK FOOTER //
// ./src/redux/iceDriftSelector.js